import React from "react";
import DataTable from "../Reusable/DataTable";
import NACell from "../Reusable/DataTable/NACell";
import APIS from "../../constant/EndPoint";
import TableActionButton from "../Reusable/TableActionButton";

const DistrictList = () => {
  const defaultColumns: any = [
    {
      header: "S.N",
      accessorKey: ".",
      cell: ({ row }: any) => <>{row?.index + 1}</>,
    },
    {
      header: "Name",
      accessorKey: "name",
      cell: NACell,
    },
    {
      header: "Total Cities",
      accessorKey: "total_state",
      cell: NACell,
    },
    {
      header: "State",
      accessorKey: "parent.name",
      cell: NACell,
    },
    {
      header: "Country",
      accessorKey: "state_name.name",
      cell: NACell,
    },
    {
      header: "Action",
      accessorKey: "id",
      cell: ({ row, getValue }: any) => (
        <>
          <TableActionButton editPath={`edit/${getValue()}`} />
        </>
      ),
    },
  ];
  return (
    <DataTable
      url={`${APIS.LOCATION}flat-location/`}
      queryKey={"districts"}
      columns={defaultColumns}
      params={{ level: 2 }}
      addNewPagePath={"/create-district"}
      tableName={"District"}
    />
  );
};

export default DistrictList;
